import React from 'react'

export function isJSX (node: any): node is JSX.Element {
  return React.isValidElement(node)
}
